$(document).ready(function(){

  var select_div = "";
  $('.tooltip-icon').mouseenter(function() {
    select_div = $(this).siblings('.variant-name').text();
    console.log(select_div);


    $('[link="'+select_div+'"]').addClass('active');
  });

  $(".tooltip-icon, .tooltip-dec").mouseleave(function() {
    if(!$('[link="'+select_div+'"]').is(':hover')){
      $('[link="'+select_div+'"]').removeClass('active');
    };
  });
  });